import React, { Component } from "react";
import { connect } from "react-redux";
import { ICONS } from "../Common/Icons";
import PageHeader from "../Common/PageHeader/PageHeader";
import _ from "i18n";
import CollaboratorCalendarContainer from "../CapacityPlanning/CollaboratorCalendarContainer";
import { initCalendarConfig, setCurrentNavPage } from "Actions";
import { fetchCollaboratorAbsenceCalendarSettings } from "Thunks";
import { inIframe } from "../../utils";
import { NotificationBar } from "../Common/Notification/NotificationBar";

class CollaboratorCalendarPage extends Component {
  componentDidMount() {
    const { dispatch } = this.props;
    const moment = require("moment");
    dispatch(initCalendarConfig());
    dispatch(setCurrentNavPage("COLLABORATOR_CALENDAR"));
    dispatch(fetchCollaboratorAbsenceCalendarSettings(moment().year()));
  }

  render() {
    return (
      <div>
        {inIframe() === false && (
          <div style={{ marginBottom: "10px" }}>
            <NotificationBar
              message={_("notifyUsingUa")}
              isUaNotification={true}
              theme="lightOrange"
            />
          </div>
        )}
        <PageHeader
          header={_("myCalendar")}
          // subHeader={_("CalendarSubTitle")}
          icon={ICONS.CALENDAR}
        />
        <div style={{ padding: "0 4rem" }}>
          <CollaboratorCalendarContainer />
        </div>
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({});

export default connect(mapStateToProps)(CollaboratorCalendarPage);



// WEBPACK FOOTER //
// ./src/components/CollaboratorCalendar/CollaboratorCalendarPage.js